import { Component, Input } from '@angular/core';
import { QueryService } from '../../comun/services/query.service';
import { FuncionesService } from '../../comun/services/funciones.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-paseo-info',
  templateUrl: './paseo-info.component.html',
  styleUrls: ['./paseo-info.component.css']
})
export class PaseoInfoComponent {
  @Input() slug!: number;
  misdatos: any = {};
  paseo: any = {};
  busy: number = 0;
  loading: boolean = false;
  mascotas: any[] = [];

  constructor(private query: QueryService, public funciones: FuncionesService, private toastr: ToastrService) { 
    this.loading = true;
  }

  ngOnInit() {
    this.getMisDatos();
  }
  
  getMisDatos() {
    this.busy++;
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {      
      this.misdatos = resultado;
      this.busy--;
      this.getPaseo();
    });
  }

  getPaseo() {
    this.busy++;
    this.query.query('paseos', 'GET', { pa_id: this.slug }).subscribe((resultado:any) => {      
      this.paseo = resultado.registros[0];
      this.getMascotas();
      this.busy--;
      this.loading = false;
    });
  }

  participar() {
    this.busy++;
    this.query.query('paseos', 'PARTICIPAR', { pa_id: this.paseo.pa_id, participante: this.paseo.participante }).subscribe((resultado:any) => {      
      // Enviar email al organizador del paseo
      let contenido = '<p>Hola ' + this.paseo.first_name + ',<br>' +
                      (!this.paseo.participante ? 'se ha apuntado un nuevo participante en tu paseo de iGuau.' : 'un participante ha abandonado tu paseo en iGuau.' ) + '</p>' +
                      '<p>' +
                      'Paseo: <b>' + this.paseo.pa_titulo + '</b>' +
                      '<br>Fecha y hora: <b>' + this.paseo.pa_fecha + ' ' + this.paseo.pa_hora + '</b>' +
                      '<br>Ubicación: <b>' + this.paseo.pa_ubicacion + '</b>' +
                      '</p>' +
                      '<p>' +
                      'Participante: <b>' + this.misdatos.first_name + '</b>' +
                      '<br>Perfil: <b>' + GlobalConstants.urlServer + 'perfil/' + this.misdatos.slug + '</b>' +
                      '</p>' +
                      '<p>Un saludo,<br>El equipo de iGuau</p>';
      let params = { plantilla: 'general.html',
                    us_id: this.paseo.ID,
                    tipo: 'ACTIVIDAD',
                    asunto: (!this.paseo.participante ? 'Nuevo participante en tu paseo de iGuau' : 'Participante cancelado en tu paseo de iGuau'),
                    contenido: contenido,
                    botonurl: GlobalConstants.urlServer,
                    boton: 'Ir a iGuau',
                    estado: 'pendiente',
                    contacto: '' // al email de contacto del usuario
                  };
      this.query.enviarMail(params).subscribe((resultado:any) => {
      });
      this.busy--;
      this.getPaseo();
    });
  }

  getMascotas() {
    this.mascotas = [];
    this.query.query('mascotas', 'GET', { ID: this.misdatos.ID }).subscribe((resultado:any) => {
      this.mascotas = resultado.registros;
      if (this.paseo.mascotas.length > 0) {
        const idsSeleccionados = new Set(
          this.paseo.mascotas.map((m : any) => m.ma_id)
        );
        this.mascotas.forEach(mascota => {
          mascota.checked = idsSeleccionados.has(mascota.ma_id);
        });
      }
    });
  }

  verEnMapa() {
    //https://www.google.es/maps/place/C.+San+Miguel,+32,+38001+Santa+Cruz+de+Tenerife/
    let direccion = this.funciones.replaceSpacesWithPlus(this.paseo.pa_ubicacion);
    window.open('https://www.google.es/maps/place/' + direccion, '_blank');
  }

  seleccionarMascota(mascota: any) {
    mascota.checked = !mascota.checked;
  }

}
